import { Box } from "@mui/material";
import React from "react";
import DemoParinted from "../RichTextArea";
import { Card } from "@egovernments/digit-ui-react-components";

const RemarksEditor = ({ setRemarks, remarks, error, setError, title = "Remarks" }) => {
  return (
    <React.Fragment>
      <Card style={{ backgroundColor: "#F7F7F7" }}>
        <div style={{ padding: "10px" }}>
          <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={1}>
            <Box gridColumn="span 2">
              <b style={{ marginRight: "2px",whiteSpace:"nowrap" }}>{title} </b>
            </Box>
            <Box gridColumn="span 12">
              {/* <DemoParinted setContent={setRemarks} content={remarks}></DemoParinted> */}
              <DemoParinted
  setContent={(value) => {
    setRemarks(value);

    if (
      value &&
      value.replace(/<[^>]*>/g, "").trim().length > 0
    ) {
      setError(false);
    }
  }}
  content={remarks}
/>
            </Box>
          </Box>
          {error && <span style={{ color: "red" }}>Please enter remarks</span>}
        </div>
      </Card>
    </React.Fragment>
  );
};

export default RemarksEditor;
